/**
 * 실시간 대기 표시 — "새 자막을 기다리는 중"(TASK_live_waiting_indicator.md).
 *
 * 카드와 같은 폭·여백으로 낸다(caption-card.tsx 의 Card/CardContent 톤을
 * 따른다) — 이전에는 한 줄짜리 작은 텍스트라 카드들 사이에서 균형이
 * 안 맞았다. 실시간 탭에만 쓴다(caption-feed.tsx §live, split-rows.tsx).
 */

import { Card, CardContent } from '@cupia/ui/card'
import { displayKo } from '../lib/languages'

/** 마지막 자막 이후 이 시간이 지나면 대기 표시를 낸다. */
export const LIVE_WAIT_AFTER_MS = 3000

export interface LiveWaitingProps {
  src: string
  dst: string
}

export function LiveWaiting({ src, dst }: LiveWaitingProps): React.ReactElement {
  return (
    <Card className="live-waiting border-dashed opacity-80" data-testid="live-waiting">
      <CardContent
        className="flex flex-row items-center gap-(--caption-gap) px-(--caption-pad-x) py-(--caption-pad-y)"
        role="status"
        aria-live="polite"
      >
        <span className="live-waiting-dot" aria-hidden />
        <div className="flex flex-col">
          <span
            className="text-[var(--color-muted-foreground)]"
            style={{ fontSize: 'var(--caption-ko-size)' }}
          >
            새 자막을 기다리는 중
          </span>
          <span className="caption-meta text-[var(--color-muted-foreground)]">
            {displayKo(src)} → {displayKo(dst)}
          </span>
        </div>
      </CardContent>
    </Card>
  )
}
